import { Box, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { MakeoverIntensity } from "../../../@types/sharedSchema";
import { MAKEOVER_INTENSITY_LEVELS } from "./makeoverIntensity";

type MakeoverIntensitySelectorProps = {
  value: MakeoverIntensity;
  onChange: (value: MakeoverIntensity) => void;
};

/** "How much to change" — a radio list from tidy/clean to a full makeover. */
export function MakeoverIntensitySelector({ value, onChange }: MakeoverIntensitySelectorProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Stack gap={1} sx={{ maxWidth: 520 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
        {translate("makeovers.intensity.title", "עוצמת השינוי")}
      </Typography>
      <RadioGroup value={value} onChange={(e) => onChange(e.target.value as MakeoverIntensity)}>
        {MAKEOVER_INTENSITY_LEVELS.map((level) => {
          const selected = level.key === value;
          return (
            <FormControlLabel
              key={level.key}
              value={level.key}
              control={<Radio color="primary" size="small" sx={{ alignSelf: "flex-start", py: 0.5 }} />}
              sx={{
                alignItems: "flex-start",
                m: 0,
                mb: 1,
                p: 1,
                borderRadius: 1.5,
                border: (theme) => `1px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
                backgroundColor: selected ? "action.hover" : "transparent"
              }}
              label={
                <Box sx={{ py: 0.25 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {translate(level.labelKey, level.labelDefault)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {translate(level.descKey, level.descDefault)}
                  </Typography>
                </Box>
              }
            />
          );
        })}
      </RadioGroup>
    </Stack>
  );
}

export default MakeoverIntensitySelector;
